import {RootState} from './interfaces'

export const payPalSelector = (state: RootState) => state.payPal
